export default {"src":"/_next/static/image/src/components/ComparisonChart/light_icon.89d7b1f1320e5bf950a6ee18f7828b05.svg","height":35,"width":36};